import React, { useState } from 'react';
import { Box, Dialog, IconButton, CardMedia } from '@mui/material';

const RoundedPlayIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="73" height="80" viewBox="0 0 73 80" fill="none">
    <g filter="url(#filter0_d_1754_12864)">
    <path d="M62.1953 34.8504C64.8551 36.3913 64.8552 40.2318 62.1953 41.7727L15.3353 68.919C12.6686 70.4639 9.33022 68.5397 9.33022 65.4579L9.33023 11.1653C9.33023 8.08344 12.6686 6.15928 15.3353 7.70409L62.1953 34.8504Z" fill="#008540"></path>
    <path d="M62.1953 34.8504C64.8551 36.3913 64.8552 40.2318 62.1953 41.7727L15.3353 68.919C12.6686 70.4639 9.33022 68.5397 9.33022 65.4579L9.33023 11.1653C9.33023 8.08344 12.6686 6.15928 15.3353 7.70409L62.1953 34.8504Z" stroke="#F7F3F0"></path>
    </g>
    <defs>
    <filter id="filter0_d_1754_12864" x="0.830078" y="0.658447" width="71.8599" height="79.3062" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
    <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix>
    <feOffset dy="2"></feOffset>
    <feGaussianBlur stdDeviation="4"></feGaussianBlur>
    <feComposite in2="hardAlpha" operator="out"></feComposite>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"></feColorMatrix>
    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1754_12864"></feBlend>
    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1754_12864" result="shape"></feBlend>
    </filter>
    </defs>
  </svg>
);

const VideoPlayer = () => {
  const [open, setOpen] = useState(false);

  // 视频和封面资源路径
  const videoSrc = '/assets/about-me.mp4'; // 'https://storage.googleapis.com/creatorspace-public/users%2Fclvmdgr2j026um901z4xjeygr%2FE8peyblte4A3vTYD-about-me.mp4'  // public 目录下路径
  const thumbnailSrc = '/assets/about-me-thumbInfo.png'; // 封面图路径

  return (
    <>
      {/* 封面图 + 播放按钮 */}
      <Box
        sx={{
          position: 'relative',
          width: '80%',
          // maxWidth: '640px',
          cursor: 'pointer',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',  // 阴影
          borderRadius: '12px',                       // 圆角
          overflow: 'hidden',                         // 让 img 和按钮也裁剪圆角
          transition: 'transform 0.3s ease, box-shadow 0.3s ease', // 悬浮动画
          '&:hover': {
            transform: 'translateY(-4px)',
          },
          '&:hover .play-button': {
            transform: 'translate(-50%, -50%) scale(1.2)', // 图标放大
          },
        }}
        onClick={() => setOpen(true)}
      >
        <img
          src={thumbnailSrc}
          alt="Video Thumbnail"
          style={{ width: '100%', height: 'auto', display: 'block' }}
        />
        <IconButton
          className="play-button"
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'transparent',
            color: '#107C4A',
            fontSize: 100,
            transition: 'transform 0.3s ease',
          }}
          aria-label="play"
        >
          <RoundedPlayIcon />
        </IconButton>
      </Box>

      {/* 弹框中的视频播放 */}
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md" fullWidth>
        <div style={{ position: 'relative', paddingTop: '56.25%' /* 16:9 */}}>
          <video
            controls
            autoPlay
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
            }}
          >
            <source src={videoSrc} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
        {/* <CardMedia
          component="video"
          image={videoSrc}
          autoPlay
          sx={{
            width: 'auto',
          }}
        /> */}
</Dialog>
    </>
  );
};

export default VideoPlayer;
